<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col class="mb-1">
          <router-link v-if="item" :to="{ name: 'EXCMTaskTypeList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-tabs>
              <b-tab :title="$t('views.excmtasktype.update.title')">
                <EXCMTaskTypeForm
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations"
                  :initial-values="retrieved"/>
              </b-tab>
              <b-tab :title="$t('views.excmtasktype.create.titleRoles')">
                <CreateRolesForTaskType
                  v-if="taskTypeOptions.length > 0 && retrieved['@id']"
                  @roleWithPermissions="retrieved.allowedAccessRole = $event"
                  :initialRoleWithPermissions="retrieved.allowedAccessRole"
                  :values="retrieved"
                ></CreateRolesForTaskType>
              </b-tab>
              <b-tab :title="$t('buttons.notifications')">
                <TaskNotifications
                  :values="retrieved"
                ></TaskNotifications>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMTaskTypeForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import CreateRolesForTaskType from './CreateRolesForTaskType'
import TaskNotifications from './TaskNotifications'

export default {
  components: {
    EXCMTaskTypeForm,
    Loader,
    CreateRolesForTaskType,
    TaskNotifications
  },

  data () {
    return {
      item: {
        customFields: []
      }
    }
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMTaskTypeUpdate')
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      taskTypeOptions: 'excmtasktype/list/items',
      isLoading: 'excmtasktype/update/isLoading',
      error: 'excmtasktype/update/error',
      deleteError: 'excmtasktype/del/error',
      deleteLoading: 'excmtasktype/del/isLoading',
      created: 'excmtasktype/create/created',
      deleted: 'excmtasktype/del/deleted',
      retrieved: 'excmtasktype/update/retrieved',
      updated: 'excmtasktype/update/updated',
      violations: 'excmtasktype/update/violations',
      customFieldUpdated: 'excmcustomfield/update/updated',
      customFieldCreated: 'excmcustomfield/create/created'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMTaskTypeList' })
    },
    updated (val) {
      if (!val) {
        return
      }

      this.$router.push({ name: 'EXCMTaskTypeList' })
    },
    customFieldUpdated: function (updated) {
      if (!updated) {
        return
      }
      this.retrieve(decodeURIComponent(this.$route.params.id))
      this.$store.state.excmcustomfield.update.updated = null
    },
    customFieldCreated: function (created) {
      if (!created) {
        return
      }
      this.retrieve(decodeURIComponent(this.$route.params.id))
      this.$store.state.excmcustomfield.create.created = null
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmtasktype/create/reset',
      deleteItem: 'excmtasktype/del/del',
      delReset: 'excmtasktype/del/reset',
      retrieve: 'excmtasktype/update/retrieve',
      updateReset: 'excmtasktype/update/reset',
      update: 'excmtasktype/update/update',
      updateRetrieved: 'excmtasktype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmtasktype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      // console.log(this.retrieved)
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
